import React from 'react';

const Preloader = () => {
    return(
        <>
		<div id="preloader">
  			<div className="loading-area">
    			<div className="circle"></div>
  			</div>
  			<div className="left-side"></div>
  			<div className="right-side"></div>
		</div>
        </>
    )
}

export default Preloader;